/* 楼盘字典-小区 */

<template>
  <div class="page_wrapper">
    <div class="dis_flex dict_wrapper">
      <div class="dis_flex">
        <a-icon type="left-circle" class="btn_back" theme="twoTone" @click="$router.go(-1)" />
        <h2 class="title_from">{{ formTitle }}</h2>
      </div>
      <a-radio-group>
        <!-- <a-button class="" v-if="!editNumInfo"  type="link"  @click="editNumInfo = !editNumInfo">
             <a-icon type="form" />编辑
        </a-button> -->
        <a-button class="" type="primary" @click="saveHandle"> 提交 </a-button>
      </a-radio-group>
    </div>

    <div class="data-form">
      <a-form-model ref="dataInfo" :model="dataInfo" :rules="rules">
        <div class="row_data">
          <!-- v-if="opt==='add'" -->
          <a-form-model-item class="item_businessDis" colon label="区域" prop="areaId">
            <a-select
              show-search
              option-filter-prop="children"
              placeholder="区域"
              v-model="dataInfo.areaId"
              @change="areaChange"
            >
              <a-select-option v-for="item in areaList" :key="item.areaId" :value="item.areaId">{{
                item.areaName
              }}</a-select-option>
            </a-select>
          </a-form-model-item>

          <!-- v-if="opt === 'add'" -->
          <a-form-model-item
            class="item_businessDis"
            colon
            label="所属商圈"
            prop="businessDistrictId"
          >
            <a-select
              show-search
              option-filter-prop="children"
              placeholder="商圈"
              v-model="dataInfo.businessDistrictId"
              :default-active-first-option="false"
              :show-arrow="true"
              :filter-option="false"
              :not-found-content="null"
              @search="businessDisSearch"
              @change="businessDistrictMethod($event,'editCommunity')">
              <a-select-option v-for="item in businessDisList" :key="item.id" :value="item.id">{{
                item.businessDistrictName
              }}</a-select-option>
            </a-select>
          </a-form-model-item>

          <!-- <a-form-model-item class="item_businessDis" v-else colon label="所属商圈" prop="businessDistrictId">
            {{ dataInfo.businessDistrictId | filterList(businessDisList) }}
            <a-input v-model="dataInfo.businessDistrictId" v-show="1 === 2" />
          </a-form-model-item> -->

          <a-form-model-item class="item_businessDis" colon label="小区名称" prop="communityFullName">
            <a-input v-model="dataInfo.communityFullName" :max-length="25" placeholder="请输入" />
            <a-input v-show="1 === 2" v-model="dataInfo.communityShortName" />
          </a-form-model-item>

          <a-form-model-item class="item_businessDis" colon label="物业费" prop="propertyFee">
            <a-input v-model="dataInfo.propertyFee" :max-length="100"  />
          </a-form-model-item>
          <a-form-model-item class="item_businessDis" colon label="水费" prop="waterFee">
            <a-input v-model="dataInfo.waterFee" placeholder="最多两位小数" :max-length="6" suffix="元/吨" />
          </a-form-model-item>
          <a-form-model-item class="item_businessDis" colon label="电费" prop="electricityFee">
            <a-input v-model="dataInfo.electricityFee" placeholder="最多两位小数" :max-length="6" suffix="元/度" />
          </a-form-model-item>
          <a-form-model-item class="item_businessDis" colon label="天然气费" prop="gasFee">
            <a-input v-model="dataInfo.gasFee" placeholder="最多两位小数" :max-length="6" suffix="元/m³" />
          </a-form-model-item>

          <a-form-model-item class="item_businessDis" colon label="小区户数">
            <a-input v-model="dataInfo.cellNumber" placeholder="小区户数" :max-length="6" suffix="户" />
          </a-form-model-item>
          <a-form-model-item class="item_businessDis" colon label="建设年代">
            <!-- <a-date-picker
              v-model="dataInfo.constructionTime"
              mode="year"
              format="YYYY"
              :open="yearShowOne"
              @openChange="openChangeOne"
              @panelChange="panelChangeOne"
            /> -->
            <a-input v-model="dataInfo.constructionTime" placeholder="例：2018-2023年" :max-length="10" suffix="" />
          </a-form-model-item>
        </div>
        <div class="row_data">
          <a-form-model-item
            class="item_businessDis"
            colon
            label="街道"
          >
            <a-select placeholder="请选择街道" show-search v-model="dataInfo.streetSelect" @change="streetChange">
              <a-select-option v-for="item in streetList" :key="item.streetFullName" :value="item.streetFullName">{{
                item.streetFullName
              }}</a-select-option>
            </a-select>
          </a-form-model-item>
          <a-form-model-item
            class="item_businessDis"
            colon
            label="门牌号(可多选)"
          >
            <a-select placeholder="请选择门牌号" mode="multiple" v-model="dataInfo.houseNumber" >
              <a-select-option v-for="item in houseNumberList" :key="item.id" :value="item.id">{{
                item.houseNumber
              }}</a-select-option>
            </a-select>
          </a-form-model-item>
          <a-form-model-item
          >
            <a-button class="" type="primary" @click="handleAdd"> 添加 </a-button>
          </a-form-model-item>

        </div>
        <div>
          <a-checkbox-group v-model="selStreetArr" @change="checkboxChange">
            <table class="tb_street" cellpadding="0" cellspace="0">
              <thead>
                <tr>
                  <td width="400px">所含街道</td>
                  <td>所含门牌号</td>
                  <!-- <td>
                    包含
                  </td> -->
                </tr>
              </thead>
            </table>
            <!-- 显示全部数据 -->
            <table class="tb_street" cellpadding="0" cellspace="0">
              <tbody v-for="(item, index) in streetListTable" :key="item.id + '_' + index">
                <!-- <template v-for="(subItem, subindex) in item.attachedInfoHouseNumberVoList">
                  <tr :key="item.id + '_' + subItem.id">
                    <td v-if="subindex == 0" :rowspan="item.attachedInfoHouseNumberVoList.length">
                      {{ item.streetFullName }}
                    </td>
                    <td>
                      <a-input v-show="3 === 2" v-model="subItem.streetId" />
                      <a-input v-show="3 === 2" v-model="subItem.houseNumber" />
                      {{ subItem.houseNumber }}
                      <a-button
                      type="link"
                      @click="minusHandle(index,subindex)"
                    ><a-icon type="minus-circle" /></a-button>
                    </td>
                  </tr>
                </template> -->
                <tr>
                  <td width="400px">{{ item.streetFullName }}</td>
                  <td class="left">
                    <template v-for="(subItem, subindex) in item.attachedInfoHouseNumberVoList" >
                      <span :key="'sub_'+subItem">
                        {{ subItem.houseNumber }}<a-button
                          type="link"
                          @click="minusHandle(index,subindex)"
                        ><a-icon type="minus-circle" /></a-button>
                      </span>
                    </template>
                  </td>
                </tr>
              </tbody>
            </table>
            <!-- 显示可操作数据 -->
            <!-- <table v-if="showCon==='canOpt'" class="tb_street" cellpadding="0" cellspace="0">
              <template v-for="(item, index) in showCanOptsStreetList">
                <tbody :key="item.id + '_' + index" v-show="item.canOptCount>0">
                  <template v-for="(subItem, subindex) in item.attachedInfoHouseNumberVoList">
                    <tr :key="item.id + '_' + subItem.id" v-if="subItem.opt">
                      <td v-if="subindex===0" :rowspan="item.canOptCount">
                        {{ item.streetFullName }}
                      </td>
                      <td >
                        <a-input v-show="3 === 2" v-model="subItem.streetId" />
                        <a-input v-show="3 === 2" v-model="subItem.houseNumber" />
                        {{ subItem.houseNumber }}
                      </td>
                      <td >
                        <a-checkbox
                          :disabled="
                            subItem.isUse === 'Y' &&
                              selStreetArr.join(',').indexOf(subItem.streetId + '_' + subItem.houseNumber) < 0
                          "
                          :value="subItem.streetId + '_' + subItem.houseNumber"
                        ></a-checkbox>
                      </td>
                    </tr>
                  </template>
                </tbody>
              </template>
            </table> -->
          </a-checkbox-group>
        </div>
      </a-form-model>
    </div>
  </div>
</template>

<script>
import {
  getCommunity,
  addCommunity,
  updateCommunity
  // ,communityList, delCommunity
} from '@/api/setting/community'
import { businessDistrictList, queryStreetByBDId } from '@/api/setting/businessdistrict'
import { areaList } from '@/api/setting/area'
import { sysList } from '@/api/setting/sys'

export default {
  name: 'CommunitySave',
  props: {},
  components: {},
  data () {
    return {
      showCon: 'canOpt', // 显示内容 canOpt=可操作数据 all=全部数据
      showConText: '显示全部',
      isStrShow: false,
      total: 0,
      submitLoading: false,
      formTitle: '新增小区信息',
      opt: 'add', // 操作 add 新增 ，edit 修改
      showNumModal: false, // 是否显示添加街道、门牌号
      editNumInfo: false, // 编辑信息
      streetNum: [], // 街道，门牌号数组

      businessDistrictListId: '', // 商圈id

      houseNumberArr: [
        {
          attachedNumber: undefined, //	门牌附号		true
          brandName: undefined, //	品牌		false
          businessType: undefined, //	经营类型		false
          houseNumber: undefined, //	门牌号		true
          id: undefined, //	id，新增时不传，修改时必传		true
          mapFlag: undefined, //	地图标记		false
          keyId: undefined //	小区ID,新增时不传，修改时必传		true
        }
      ], // 门牌号

      showHouseArr: [],
      selStreetArr: [], // 选择的街道门牌信息
      streetHouseNumArr: [],
      sysInfo: {}, // 系统信息
      areaList: [], // 区域信息
      queryArea: {
        areaName: undefined, //	名称
        level: 3, // 等级（1：省 2：市 3：区）
        parentId: undefined //	父类ID
      },
      querySysParam: {
        pageNum: 1, // 当前页数	query	true
        pageSize: 1, //	分页大小	query	true
        companyName: undefined, // 公司名称	query	false
        isAsc: undefined, // 排序的方向	query	false
        orderByColumn: undefined // 排序列	query	false
      },
      queryParam: {
        businessDistrictName: undefined, // 商圈名称
        districtId: undefined // 区域ID
      },
      businessDisList: [],
      loading: false,
      streetList: [], // 街道列表
      streetListTable: [], // 街道列表

      showCanOptsStreetList: [], // 街道列表(隐藏后的街道列表)
      houseNumList: [], // 门牌号列表

      districtOpts: [], // 区域
      businessTypeOpts: [], // 经营类型
      industrySubOpts: [], // 经营子类
      streetSelect: [], // 街道选择
      houseNumberList: [], // 门牌号
      parentStreet: {},
      // 表单参数
      dataInfo: {
        businessDistrictId: undefined, //	商圈ID		true
        communityFullName: undefined, //	小区全称		true
        id: undefined, //	id，新增时不传，修改时必传		true
        streetIds: {}, //	街道IDs、附号IDs		true

        areaId: undefined, // 区域id
        propertyFee: undefined, // 物业费
        waterFee: undefined, // 水费
        electricityFee: undefined, // 电费
        gasFee: undefined, // 天然气费
        cellNumber: undefined, // 小区户数
        constructionTime: undefined, // 建设年代
        streetSelect: undefined, // 街道
        houseNumber: undefined // 门牌号
      },
      keyId: undefined,
      rules: {
        businessDistrictId: [{ required: true, message: '必选', trigger: 'blur' }],
        communityFullName: [{ required: true, message: '必填', trigger: 'blur' }],
        streetIdselectricityFee: [{ required: true, message: '必填', trigger: 'blur' }],

        areaId: [{ required: true, message: '必填', trigger: 'blur' }],
        propertyFee: [
          {
            required: true,
            message: '必填',
            trigger: 'blur'
          }
        ],
        waterFee: [
          {
            required: true,
            pattern: /^((([0-9]+)|([1-9][0-9]*))(.[0-9]{0,2}){0,1})$/,
            message: '格式错误',
            trigger: 'blur'
          }
        ],
        electricityFee: [
          {
            required: true,
            pattern: /^((([0-9]+)|([1-9][0-9]*))(.[0-9]{0,2}){0,1})$/,
            message: '格式错误',
            trigger: 'blur'
          }
        ],
        gasFee: [
          {
            required: false,
            pattern: /^((([0-9]+)|([1-9][0-9]*))(.[0-9]{0,2}){0,1})$/,
            message: '格式错误',
            trigger: 'blur'
          }
        ]
      },

      yearShowOne: false // 年度打开关闭状态，true为打开，false为关闭
    }
  },
  created () {
    // 获取区域域
    this.getSysInfo()
    this.getBusinessDistrict()
    if (this.dataInfo.businessDistrictId && typeof this.dataInfo.businessDistrictId !== 'undefined') {
      this.getStreetHouseNumList()
    }

    // 小区id
    let keyId = this.$route.query.dataId
    if (keyId !== '' && keyId != null && typeof keyId !== 'undefined') {
      // 修改
      keyId = parseInt(this.$route.query.dataId)

      // 小区详情
      getCommunity(keyId).then((response) => {
        if (response.code === 200) {
          this.dataInfo = response.data
          // 小区所属商圈所含街道、门牌号信息
          this.getStreetHouseNumList('detail')
          const streetIds_ = this.dataInfo.streetIds
          for (const sid in streetIds_) {
            const numObj = streetIds_[sid]
            if (numObj != null && typeof numObj !== 'undefined') {
              const numArr = numObj.split(',')
              if (numArr != null && numArr.length > 0) {
                for (const hNum of numArr) {
                  const sid_numId = sid + '_' + hNum
                  this.selStreetArr.push(sid_numId)
                }
              }
            }
          }
        }
      })
      this.opt = 'edit'
      this.formTitle = '修改小区信息'
    } else {
      this.opt = 'add'
      this.editNumInfo = true
      this.formTitle = '新增小区信息'
    }
  },
  computed: {},
  watch: {},
  methods: {
    filterOption (input, option) {
      return option.value.toLowerCase().indexOf(input.toLowerCase()) >= 0
    },
    clearData () {
      this.parentStreet = {}
      this.houseNumberList = []
      this.dataInfo.streetSelect = []
      this.dataInfo.houseNumber = []
    },
    streetChange (val) {
      const findVal = this.streetList.find(v => v.streetFullName == val)
      if (findVal) {
        this.parentStreet = JSON.parse(JSON.stringify(findVal))
        this.houseNumberList = findVal.attachedInfoHouseNumberVoList.filter(v => v.isUse != 'Y')
      }
      this.$set(this.dataInfo, 'houseNumber', [])
    },
    handleAdd () {
      // dataInfo.houseNumber
      // 获取子集
      const addList = this.houseNumberList.filter(v => this.dataInfo.houseNumber.indexOf(v.id) > -1)
      // 获取分级
      // 查找是否存在相同的
      const diff = this.streetListTable.find(v => v.id == this.parentStreet.id)
      if (addList.length === 0) return
      if (diff) {
        const diffIndex = this.streetListTable.findIndex(v => v.id == this.parentStreet.id)
        const newArr = this.removeDuplicateObj([...this.streetListTable[diffIndex].attachedInfoHouseNumberVoList, ...addList])
        this.streetListTable[diffIndex].attachedInfoHouseNumberVoList = newArr
      } else {
        this.parentStreet.attachedInfoHouseNumberVoList = addList
        this.streetListTable.push(this.parentStreet)
      }
      this.clearData()
    },
    removeDuplicateObj (arr) {
        const obj = {}
        arr = arr.reduce((newArr, next) => {
          obj[next.id] ? '' : (obj[next.id] = true && newArr.push(next))
          return newArr
        }, [])
        return arr
    },
    minusHandle (index, subItem) {
      this.streetListTable[index].attachedInfoHouseNumberVoList.splice(subItem, 1)
      if (this.streetListTable[index].attachedInfoHouseNumberVoList.length === 0) {
        this.streetListTable.splice(index, 1)
      }
    },
    showStrBtn () {
      this.showCon = this.showCon === 'canOpt' ? 'all' : 'canOpt'
      this.showConText = this.showCon === 'canOpt' ? '显示全部' : '显示可操作'
    },
    // 弹出日历和关闭日历的回调
    openChangeOne (status) {
      if (status) {
        this.yearShowOne = true
      }
    },
    // 得到年份选择器的值
    panelChangeOne (value) {
      this.dataInfo.constructionTime = value
      this.yearShowOne = false
    },
    /** 查询系统设置信息列表 */
    getSysInfo () {
      this.loading = true
      sysList(this.querySysParam).then((response) => {
        if (response.code === 200) {
          const resData = response.data
          this.total = resData.total
          if (this.total > 0) {
            this.sysInfo = resData.records[0]
            this.queryArea = {
              areaName: undefined, //	名称
              level: 3, // 等级（1：省 2：市 3：区）
              parentId: this.sysInfo.companyCityId //	父类ID
            }
            areaList(this.queryArea).then((res) => {
              if (res.code === 200) {
                const resData = res.data
                const areaList = []
                if (resData != null && resData.length > 0) {
                  for (let i = 0; i < resData.length; i++) {
                    areaList.push({ areaId: resData[i].areaId, areaName: resData[i].areaName, children: [] })
                  }
                  this.areaList = areaList
                }
              }
            })
          } else {
            this.queryArea.parentId = ''
            this.$message.error('公司设置所在市信息获取失败')
          }
        }
        this.loading = false
      })
    },

    // 获取商圈列表
    getBusinessDistrict () {
      this.loading = true
      businessDistrictList(this.queryParam).then((response) => {
        if (response.code === 200) {
          const resData = response.data
          this.businessDisList = resData
        }
        this.loading = false
      })
    },
    // 根据商圈id 获取街道列表+门牌号列表
    getStreetHouseNumList (type) {
      this.loading = true
      const id = parseInt(this.dataInfo.businessDistrictId)
      queryStreetByBDId(id).then((response) => {
        this.streetListTable = []
        if (response.code === 200) {
          const resData = response.data
          this.streetList = JSON.parse(JSON.stringify(resData))

          this.showCanOptsStreetList = []
          for (const street of resData) {
             const houseNumberList = street.attachedInfoHouseNumberVoList
             const houseNumberList_ = []
             let canOptCount_ = 0
             if (houseNumberList && houseNumberList.length > 0) {
              const listNumber = houseNumberList.filter(v => this.selStreetArr.indexOf(v.streetId + '_' + v.houseNumber) > -1)
              if (listNumber.length > 0) {
                const strObj = JSON.parse(JSON.stringify(street))
                strObj.attachedInfoHouseNumberVoList = listNumber
                this.streetListTable.push(strObj)
              }
              for (const h of houseNumberList) {
                if (h.isUse === 'Y' && this.selStreetArr.join(',').indexOf(h.streetId + '_' + h.houseNumber) < 0) {
                  h.opt = false// 不可操作
                } else {
                   h.opt = true
                   canOptCount_++
                   houseNumberList_.push(h)
                }
              }
             }
             street.canOptCount = canOptCount_
             street.attachedInfoHouseNumberVoList = houseNumberList_
             this.showCanOptsStreetList.push(street)
            // 可展示的数据
          }
          // const streetList_Filter = resData.map((item) => {
          //   return (
          //     item.attachedInfoHouseNumberVoList.filter((v) => {
          //       return v.isUse === 'N'
          //     }).length > 0
          //   )
          // })

          let len = 0
          for (const street of this.streetList) {
            len += street.attachedInfoHouseNumberVoList.length
          }
          if (len <= 0) {
            this.$message.error('该商圈下街道信息不完整，请重新选择商圈或完善街道相关信息', 3)
          }
        }
        this.loading = false
      })
    },
    // 区域改变事件
    areaChange (val) {
      // 重置商圈信息
      this.dataInfo.businessDistrictId = undefined
      // 重置街道信息
      this.dataInfo.streetSelect = []
      this.showCanOptsStreetList = []
      // this.streetList = []
      // 重获商圈列表
     this.queryParam.districtId = val
      this.queryParam.businessDistrictName = undefined
     this.getBusinessDistrict()
    },

    // 商圈的搜索
    businessDisSearch (value) {
      this.queryParam.districtId = undefined
      this.queryParam.businessDistrictName = value
      this.getBusinessDistrict(this.queryParam)
    },
    // 根据商圈改变事件
    businessDistrictMethod (val, pageName) {
      console.log(this.businessDisList)
      this.dataInfo.streetSelect = []
      const businessDis = this.businessDisList.find((item) => {
        return item.id === val
      })
      // 区域
      this.dataInfo.areaId = businessDis.districId
      this.dataInfo.businessDistrictId = businessDis.id
      this.getDistrictBusinessInfo(this.dataInfo.areaId)

      this.getStreetHouseNumList()
    },
     // 根据区域id，获取区域、商圈信息（通过街道反查信息）
    getDistrictBusinessInfo (districtId) {
      const regionChild = this.areaList.find((item) => {
        return item.areaId === districtId
      })
      this.getBusinessDistrict({ businessDistrictName: '', districtId: regionChild.areaId })
    },

    checkboxChange () {
      if (this.selStreetArr && this.selStreetArr.length > 0) {
        let streetId = ''
        let houseNum = ''
        const streetIdArr = []
        for (const item of this.selStreetArr) {
          streetId = item.split('_')[0]
          streetIdArr.push(streetId)
        }
        var set = new Set(streetIdArr)
        // 将set转换为数组
        const [...newStreetArr_] = set
        const street_houseNumArr = []
        let houseNumArr_ = []
        const street_houseNumObj = {}

        for (const newObj of newStreetArr_) {
          houseNumArr_ = []
          for (const s of this.selStreetArr) {
            streetId = s.split('_')[0]
            houseNum = s.split('_')[1]
            if (newObj === streetId) {
              houseNumArr_.push(houseNum)
              street_houseNumObj[streetId] = houseNumArr_.join(',')
            }
          }
        }
        this.dataInfo.streetIds = street_houseNumObj
      } else {
        this.dataInfo.streetIds = {}
      }
    },
    /** 提交按钮 */
    saveHandle: function () {
      let flag = false
      const streetIds = {}
      const allSelStreetArr = []
      for (const key in this.streetListTable) {
        const arr = this.streetListTable[key].attachedInfoHouseNumberVoList.map(v => v.houseNumber).join(',')
        // let newArr = this.streetListTable[key].attachedInfoHouseNumberVoList.map(v=>v.streetId + '_' + v.houseNumber)
        streetIds[this.streetListTable[key].id] = arr
        // allSelStreetArr.push(...newArr)
      }
      this.dataInfo.streetIds = streetIds
      for (const key in this.dataInfo.streetIds) {
        if (key) {
          flag = true
          break
        } else {
          continue
        }
      }
      // let deleteArr = []
      // // 对比
      // this.selStreetArr.map(v => {
      //   if(allSelStreetArr.indexOf(v) == -1){
      //     deleteArr.push(v)
      //   }
      // })
      if (flag) {
        this.$refs.dataInfo.validate((valid) => {
          if (valid) {
            this.submitLoading = true
            // this.dataInfo.constructionTime = this.$moment({ ...this.dataInfo.constructionTime }).format('YYYY')
            const dataInfoObj = JSON.parse(JSON.stringify(this.dataInfo))
            // 去掉街道和门牌号
            delete dataInfoObj.streetSelect
            delete dataInfoObj.houseNumber
            if (this.dataInfo.id !== undefined) {
              updateCommunity(dataInfoObj)
                .then((response) => {
                  this.$message.success('修改成功', 3)
                  this.goList()
                })
                .finally(() => {
                  this.submitLoading = false
                })
            } else {
              addCommunity(dataInfoObj)
                .then((response) => {
                  this.$message.success('新增成功', 3)
                  this.goList()
                })
                .finally(() => {
                  this.submitLoading = false
                })
            }
          } else {
            return false
          }
        })
      } else {
        this.$message.error('无效数据', 3)
      }
    },
    pointChange (value) {
      // console.log('changed', value);
    },
    goList () {
      this.$router.go(-1)
    }
  },
  filters: {
    filterDict (val, opts) {
      if (!val) return
      for (const d of opts) {
        if (d.dictValue === val) {
          return d.dictLabel
        }
      }
    },
    filterList (val, list) {
      if (!val) return
      for (const item of list) {
        if (item.id == val) {
          return item.businessDistrictName
        }
      }
    }
  }
}
</script>
<style lang="less" scoped>
.dict_wrapper,
.data-form {
  background: #fff;
  padding: 20px;
}
.data-form {
  margin-top: 10px;
}
.ml20 {
  margin-left: 20px;
}
.dis_flex {
  display: flex;
  align-items: center;
}
.dict_wrapper {
  display: flex;
  justify-content: space-between;
}
.title_from {
  font-weight: bold;
  font-size: 20px;
  margin-bottom: 0px;
}
.row_data {
  display: flex;
  flex-wrap: wrap;
  align-items: flex-end;
}

.item_businessDis {
  width: 280px;
  margin-right: 20px;
}
.btn_opt {
  margin-right: 50px;
}
.ant-checkbox-group,
.tb_street {
  width: 100%;
}
.tb_street tr td {
  // width: 33%;
  border: 1px solid #f2f2f2;
  padding: 5px 5px;
  text-align: center;
  height: 46px;
  &.left{
    padding: 5px 10px;
    text-align: left;
    span{
      display: inline-block;
      width: 80px;
    }
    .ant-btn{
      padding-left: 6px;
    }
  }
}
/* .tb_street tr td:last-child{
  border:none;
  text-align:left;
} */
.item_street {
  margin-bottom: 0px;
}
</style>
